var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('trips-map',{staticClass:"mapbox-widget",attrs:{"accessToken":_vm.mapboxAccessToken,"start":_vm.startPoint,"stop":_vm.endPoint,"events":_vm.events,"stopOvers":_vm.stops,"lineCoordinates":_vm.lineCoordinates,"interactive":_vm.interactive,"fullscreen":_vm.fullscreen}})
}
var staticRenderFns = []

export { render, staticRenderFns }